var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-md-12 col-lg-12 col-sm-12 pl-0 xs-pr-0" },
    [
      _c("div", { staticClass: "first_table" }, [
        _c("table", { staticClass: "table activity-tracker-table" }, [
          _vm._m(0),
          _c(
            "tbody",
            _vm._l(_vm.rolesList, function (rowVal, index) {
              return _c(
                "tr",
                {
                  key: index,
                  class: { "on-hover": _vm.evenHover[index] },
                  on: {
                    mouseover: function ($event) {
                      return _vm.mouseOver(index)
                    },
                    mouseleave: function ($event) {
                      return _vm.mouseOut(index)
                    },
                  },
                },
                [
                  _c("td", { staticClass: "menu-td" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown dropdown-export export-activity-menu",
                        attrs: { id: "trackerActionDots" + index },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { "margin-top": "1px" },
                            attrs: { "data-toggle": "dropdown" },
                            on: { click: _vm.menuDropdown },
                          },
                          [_vm._m(1, true)]
                        ),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "activitytrackermenu dropdown-menu export-menu",
                            class: _vm.changeClass ? "addReverse" : "",
                          },
                          [
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.updateActiveStatus(rowVal)
                                  },
                                },
                              },
                              [
                                rowVal.is_active
                                  ? _c("a", [
                                      _c("img", {
                                        staticClass: "tracker-images",
                                        attrs: {
                                          src: "/static/images/icons/delete_icon.svg",
                                          alt: "delete-icon",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-color-delete-red menu-dots-links",
                                        },
                                        [_vm._v("Deactive Role")]
                                      ),
                                    ])
                                  : _c("a", [
                                      _c("img", {
                                        staticClass: "tracker-images",
                                        attrs: {
                                          src: "/static/images/icons/check.svg",
                                          alt: "check-icon",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-color-blue" },
                                        [_vm._v("Activate Role")]
                                      ),
                                    ]),
                              ]
                            ),
                            _c("li", { staticClass: "divider" }),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.EditService(rowVal)
                                  },
                                },
                              },
                              [_vm._m(2, true)]
                            ),
                            _c("li", { staticClass: "divider" }),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.ExportRole(rowVal)
                                  },
                                },
                              },
                              [_vm._m(3, true)]
                            ),
                            _c("li", { staticClass: "divider" }),
                            _c(
                              "li",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.importFile(rowVal)
                                  },
                                },
                              },
                              [_vm._m(4, true)]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("td", { staticClass: "dropdown-column" }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "data_table shadow_col" }, [
        _c(
          "table",
          {
            staticClass:
              "table dataList table-responsive activity-tracker-table",
          },
          [
            _vm._m(5),
            _c(
              "tbody",
              _vm._l(_vm.rolesList, function (rowVal, index) {
                return _c(
                  "tr",
                  {
                    key: index,
                    class: { "on-hover": _vm.evenHover[index] },
                    on: {
                      mouseover: function ($event) {
                        return _vm.mouseOver(index)
                      },
                      mouseleave: function ($event) {
                        return _vm.mouseOut(index)
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "wd-20" },
                      [
                        _c(
                          "base-tooltip",
                          { attrs: { content: rowVal.role_name } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(rowVal.role_name.substring(0, 10)) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "td",
                      { staticClass: "wd-25" },
                      [
                        _c(
                          "base-tooltip",
                          { attrs: { content: rowVal.description } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(rowVal.description.substring(0, 19)) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("td", {}, [
                      rowVal.is_active
                        ? _c("img", {
                            staticClass: "tracker-images center",
                            attrs: {
                              src: "/static/images/icons/check.svg",
                              alt: "check-icon",
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c(
                      "td",
                      { staticClass: "wd-18" },
                      [
                        rowVal.accountTypeDesc
                          ? _c(
                              "base-tooltip",
                              { attrs: { content: rowVal.accountTypeDesc } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      rowVal.accountTypeDesc.length > 3
                                        ? rowVal.accountTypeDesc.substring(
                                            0,
                                            10
                                          )
                                        : rowVal.accountTypeDesc
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("td", {}, [
                      _c(
                        "a",
                        {
                          staticClass: "cursor-pointer",
                          on: {
                            click: function ($event) {
                              return _vm.viewRBACTemplate(rowVal)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "tracker-images",
                            attrs: {
                              src: "/static/images/icons/eye.svg",
                              alt: "eye-icon",
                            },
                          }),
                          _c("span", [_vm._v("View")]),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
      _vm.rolesList.length === 0
        ? _c("div", { staticClass: "norecords_wrapper" }, [
            _c("div", { staticClass: "no-records-found" }, [
              _vm._v("No Roles Found"),
            ]),
          ])
        : _vm._e(),
      _c("rbac-services-modal", {
        attrs: {
          roleDetails: _vm.roleDetails,
          selectedRoleId: _vm.selectedRoleId,
          selectedRoleName: _vm.selectedRoleName,
          selectedRoleServices: _vm.selectedRoleServices,
        },
      }),
      _c("rbac-view-services-modal", {
        attrs: {
          selectedRoleName: _vm.selectedRoleName,
          selectedRoleServices: _vm.selectedRoleServices,
        },
      }),
      _c("rbac-active-status-modal", {
        attrs: { roleDetails: _vm.roleDetails },
        on: { updateRoleActiveStatus: _vm.getListOfRoles },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "filter-th wd-65" }),
        _c("th", { staticClass: "wd-20" }, [_vm._v("Name")]),
        _c("th", { staticClass: "wd-25" }, [_vm._v("Description")]),
        _c("th", {}, [_vm._v("Active")]),
        _c("th", { staticClass: "wd-18" }, [_vm._v("AccountType")]),
        _c("th", {}, [_vm._v("Permission")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "dropdown-toggle" }, [
      _c("i", { staticClass: "fa fa-ellipsis-v menu-dots cursor-pointer" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red menu-dots-links" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/update_service.svg",
          alt: "update-icon",
        },
      }),
      _c("span", { staticClass: "text-color-blue" }, [
        _vm._v("Update Services"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red menu-dots-links" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/share_icon.svg",
          alt: "share-icon",
        },
      }),
      _c("span", { staticClass: "text-color-blue" }, [_vm._v("Export Role")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red menu-dots-links" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/profile_icon.svg",
          alt: "profile-icon",
        },
      }),
      _c("span", { staticClass: "text-color-blue" }, [_vm._v("Import Role")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", { staticClass: "shadow_col" }, [
        _c("th", { staticClass: "wd-20" }, [_vm._v("Name")]),
        _c("th", { staticClass: "wd-25" }, [_vm._v("Description")]),
        _c("th", {}, [_vm._v("Active")]),
        _c("th", { staticClass: "wd-18" }, [_vm._v("AccountType")]),
        _c("th", {}, [_vm._v("Permission")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }